<template>
    <div>
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="500px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        <template v-if="!isNewStore">
                            Edycja magazynku <strong>{{ storeData.name }}</strong>
                        </template>
                        <template v-else>
                            Nowy magazyn
                        </template>
                    </h1>
                </v-card-title>

                <v-card-text class="text-center">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="store.name"
                                label="Nazwa"
                                :error-messages="storeNameErrors"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                    <v-checkbox
                        v-model="store.isActive"
                        label="Czy aktywny?"
                        hide-details
                    />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        :disabled="actionLoading"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Zapisz"
                        :loading="actionLoading"
                        @click="saveStore"
                    >
                        Zapisz
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'StoreDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        storeData: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            store: {
                name: null,
                isActive: true,
            },
            actionLoading: false,
        }
    },
    validations() {
        const validations = {
            store: {
                name: {
                    required
                }
            }
        }

        return validations
    },
    computed: {
        isNewStore() {
            return isEmpty(this.storeData)
        },

        // Walidacje
        storeNameErrors() {
            const errors = []

            if (!this.$v.store.name.$dirty) return errors
            !this.$v.store.name.required && errors.push('Proszę podać nazwę.')

            return errors
        },
    },
    watch: {
        storeData(value) {
            if (!isEmpty(value)) {
                this.store = JSON.parse(JSON.stringify(value))
            }
        }
    },
    methods: {
        saveStore() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            let action = this.isNewStore ? 'createStore' : 'updateStore'

            this.actionLoading = true
            this.$store.dispatch(`shipping/configurations/${action}`, this.store)
                .then(() => {
                    this.$emit('on-confirm', action)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.store.name = null
                this.store.isActive = true
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        },
    }
}
</script>